import React from 'react';
import { WelcomeProps } from '../interfaces/components';
import useWindowDimensions from '../utils/hooks/useWindowDimensions';
import { WelcomeContent } from '../content';
import WelcomeDesktop from './Welcome/WelcomeDesktop';
import WelcomeMobile from './Welcome/WelcomeMobile';

const Welcome = ({ activeLocale, active, setActive, setAudioModal }: WelcomeProps) => {
  const { subTitle, title, description } = WelcomeContent[activeLocale as keyof typeof WelcomeContent];

  const { width } = useWindowDimensions();

  const onClose = () => {
    setActive();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'startTagManager' });
  };

  const commonProps = {
    activeLocale,
    active,
    subTitle,
    title,
    description,
    setActive,
    setAudioModal,
    onClose,
  };

  return width > 768 ? <WelcomeDesktop {...commonProps} /> : <WelcomeMobile {...commonProps} />;
};

export default Welcome;
